var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "nav navbar-top-links navbar-right" }, [
    _c("li", [
      _c("span", { attrs: { id: "user_email" } }, [_vm._v(_vm._s(_vm.email))])
    ]),
    _vm._v(" "),
    _c("li", [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.logout()
            }
          }
        },
        [_vm._v("Logout")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15741403", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15741403","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AuthenticatedAppHeader.vue
// module id = null
// module chunks = 